import { useEffect, useState } from 'react';

/**
 * Like useState, but persisted in sessionStorage under `key` so the value
 * survives navigating away and back within the same tab. Used to keep the
 * Boxes list's search/sort/filters when jumping to a task and returning.
 */
export function useSessionState<T>(key: string, initialValue: T) {
  const [state, setState] = useState<T>(() => {
    try {
      const raw = sessionStorage.getItem(key);
      return raw !== null ? (JSON.parse(raw) as T) : initialValue;
    } catch {
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      sessionStorage.setItem(key, JSON.stringify(state));
    } catch {
      // ignore write errors (storage disabled/full)
    }
  }, [key, state]);

  return [state, setState] as const;
}
